export enum ScheduleBoardRegions {
	WORK_ORDER = 'WORK_ORDER',
	TOOLBAR = 'TOOLBAR',
	BOARD = 'BOARD',
}
